module.exports = "/assets/data/9a9fb570d7df2d816d406728b1179fd3-LA21.data.json";